konnyScript(function ($) {
  // Tab Slide
  var tabNavSlide = new Swiper("#tab_nav_swiper_slide", {
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: false,
  });

  function getCurrentTranslateX($wrapper){
    const m = window.getComputedStyle($wrapper[0]).transform;
    if (!m || m === 'none') return 0;
    const vals = m.match(/matrix(3d)?\((.+)\)/);
    if (!vals) return 0;
    const nums = vals[2].split(',').map(parseFloat);
    // matrix(a,b,c,d,tx,ty) or matrix3d(..., tx, ty, tz)
    return (vals[1] === '3d') ? nums[12] : nums[4];
  }

  // Tab Scroll
  (function () {
    const $tabs = $('.eventWrap .navWrap li');
    const sections = [...Array($tabs.length)].map((_, i) => $('#tabCon' + (i + 1)));
    const isMobile = () => $(window).width() <= 750;

    let isFromClick = false;
    let scrollWatcher;
    let lastActiveIndex = -1;

    $('#tab_nav_swiper_slide a').on('click', function (e) {
      e.preventDefault();
      const $li = $(this).closest('li');
      const index = $li.index();

      $li.addClass('on').siblings().removeClass('on');
      tabNavSlide.slideTo(index); 

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.eventWrap .navWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const fixedTop = parseInt(getComputedStyle(document.querySelector('.eventWrap .navWrap')).top, 10)
        || (window.innerWidth <= 749 ? 60 : 68);

      const targetSection = $('#tabCon' + (index + 1));
      if (targetSection.length) {
        let targetTop = targetSection.offset().top - fixHeight - fixedTop;
        if (isMobile()) targetTop += 1;

        isFromClick = true;
        window.scrollTo({ top: targetTop, behavior: 'smooth' });

        cancelAnimationFrame(scrollWatcher);
        (function watchScroll() {
          const current = $(window).scrollTop();
          if (Math.abs(current - targetTop) < 3) { isFromClick = false; return; }
          scrollWatcher = requestAnimationFrame(watchScroll);
        })();
      }

      if (isMobile()) {
        const container = tabNavSlide.el;
        const $container = $(container);
        const $wrapper = $container.find('.swiper-wrapper');
        const cw = $container.width();
        const sLeft = $li.position().left;
        const sW = $li.outerWidth(true);
        const $last = $tabs.last();
        const maxX = $last.position().left + $last.outerWidth(true) - cw;
        let x = ( $tabs.length <= 3 ) ? 0 : sLeft - (cw/2) + (sW/2);
        x = Math.max(0, Math.min(x, maxX));
        $wrapper.css('transform', `translate3d(${-x}px,0,0)`);
      }
    });

    $(window).on('load scroll', function () {
      if (!$('.eventWrap .navWrap').length) return;

      const $navWrap = $('.eventWrap .navWrap');
      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $navWrap.outerHeight() || 0;
      const fixedTop = parseInt(getComputedStyle($navWrap[0]).top, 10)
        || (window.innerWidth <= 749 ? 60 : 68);
      const winTop = $(window).scrollTop();
      const bwNavTop = $('.eventWrap .navArea').offset().top - fixedTop;

      $navWrap.toggleClass('fixed', winTop > bwNavTop);
      if (isFromClick) return;

      let activeIndex = 0;
      const ACTIVATION_OFFSET = -100;
      for (let i = sections.length - 1; i >= 0; i--) {
        if (winTop > sections[i].offset().top - (navHeight + fixedTop) + ACTIVATION_OFFSET) {
          activeIndex = i;
          break;
        }
      }

      if (activeIndex === lastActiveIndex) return;
      lastActiveIndex = activeIndex;

      const $activeTab = $tabs.eq(activeIndex);
      $activeTab.addClass('on').siblings().removeClass('on');

      // try { tabNavSlide.slideTo(activeIndex, 0); } catch(e){}

      if (isMobile()) {
        const container = tabNavSlide.el;
        const $container = $(container);
        const $wrapper = $container.find('.swiper-wrapper');
        const cw = $container.width();
        const sLeft = $activeTab.position().left;
        const sW = $activeTab.outerWidth(true);
        const $last = $tabs.last();
        const maxX = $last.position().left + $last.outerWidth(true) - cw;

        let targetX = ($tabs.length <= 3) ? 0 : sLeft - (cw/2) + (sW/2);
        targetX = Math.max(0, Math.min(targetX, maxX));
        const desiredTx = -targetX;

        const currTx = getCurrentTranslateX($wrapper);
        if (Math.abs(currTx - desiredTx) < 2) return;

        $wrapper.css('transition', 'transform .25s ease')
                .css('transform', `translate3d(${desiredTx}px,0,0)`);
      }
    });
  })();
});
